<!-- 百分比上传组件 -->

<template>
<div class="load-btn">
  <el-upload ref="upload"
    :action="upUrl"
    :class="isAct"
    :before-upload="prevCtrls"
    :on-success="successCtrls"
    :file-list="fileList"
    :disabled="ableSet"
    list-type="picture-card"
    :data="fileData"
    :on-remove="handleRemove"
    :on-preview="handlePictureCardPreview"
    :on-exceed="handleExceed">
    <i class="el-icon-plus"></i>
  </el-upload>
  <el-dialog :visible.sync="dialogVisible">
    <img width="100%" :src="dialogImageUrl" alt="">
  </el-dialog>
</div>
</template>

<script>
import {
  getToken
} from '@/utils/auth';
import {
  getFileToken
} from '@/api/account';
export default {
  props: ['ableSure',"limit","viewType"],
  data() {
    return {
      fileData: {},
      imgUrl: '',
      fileToken: '',
      upUrl:'',
      dialogVisible:false,
      dialogImageUrl: '',
      fileList:[],
      imgIds:[],
      imgNum:1,

      ableSet:false,
      isAct:''
    }
  },
  watch: {
    ableSure: function(dat) {
        if(this.ableSure){
          // console.log(dat);
          var arr = this.ableSure.split(',');

          if(arr.length>0){
              for(var index in arr){
                  this.imgInit(arr[index]);
              }
          }
        }
    }
  },
  methods: {
    prevCtrls: function(file) {
      let nameArr = file.type.split('/');
      let fileType = nameArr[nameArr.length - 1];

      if (fileType != 'jpeg' && fileType != 'png') {
        this.$message({
          message: '请上传格式为 JPGE 或 PNG 的文件！',
          type: 'error'
        })
        return false;
      } else if (file.size / 1024 / 1024 > 10) {
        this.$message({
          message: '文件大小不能超过 10M！',
          type: 'error'
        })
        return false;
      } else {
        this.fileData.token = getToken();
        this.fileData.fileSize = file.size;

        return true;

      }
    },
    successCtrls: function(data) {
        this.imgIds.push(data.payload.id);
        this.$emit('upFileId', this.imgIds.join());
    },

    imgInit: function(dat) {
        if(dat){
            var url = process.env.BASE_API + '/File/File/view/token/' + this.fileToken + '/id/' + dat;
            var file = {
              id:dat,
              name: dat + '.jpeg',
              url: url
            }
            this.fileList.push(file);
        }
    },

    handleExceed: function(files, fileList) {
        var num = 1;
        if(this.limit){
            this.imgNum=this.limit;
        }
        if(fileList.length+files.length>this.imgNum){
            this.$message({
              message: "最多只能上传"+this.imgNum+"个文件!",
              type: 'error'
            });
        }
    },
    handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
    },
    handleRemove(file, fileList) {
      for(var index in this.imgIds){
          if(this.imgIds[index] == file.id ){
              this.imgIds.splice(index,1);
          }
      }
      for(var index in this.fileList){
        if(this.fileList[index].id == file.id){
            this.fileList.splice(index,1);
        }
      }


      this.$emit('upFileId', this.imgIds.join());

    },
  },

  created: function() {
    this.upUrl = process.env.BASE_API + '/File/File/upload';
    if(this.viewType == 2){
        this.ableSet = true;
        this.isAct = 'addHide';
    }
    getFileToken().then(response => {
        this.fileToken = response.resultStatus.token;
        // console.log(this.ableSure);
        if(this.ableSure){

          var arr = this.ableSure.split(',');
          if(arr.length>0){
              for(var index in arr){
                  this.imgInit(arr[index]);
              }
          }
        }

    })

  }
}
</script>

<style scope>
.upload-btn {
  display: inline-block;
}

.progressBox {
  width: 480px;
  margin-top: 6px;
}

.imgBox {
  height: 120px;
  margin-bottom: 9px;
}

.imgBox img {
  height: 100%;
}

.addHide .el-upload--picture-card{
  display: none;
}

</style>



// WEBPACK FOOTER //
// uploadCards.vue?c07f89e4